import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeavePatientAddressForm from './CSSZSickLeavePatientAddressForm';
import { CSSZAddress } from '../../Interfaces/CSSZ.interface';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import { CSSZSickLeaveValues } from '../CSSZSickLeaveCertificateCreate/CSSZSickLeaveCertificateCreate';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	userId: string;
	onSubmit: (values: CSSZAddress) => void;
	collectedValues?: DeepPartial<CSSZSickLeaveValues>;
}

const CSSZSickLeavePatientAddressFormModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeavePatientAddress.modalTitle'
			size={Size.LG}>
			<CSSZSickLeavePatientAddressForm
				userId={props.userId}
				onSubmit={props.onSubmit}
				collectedValues={props.collectedValues}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeavePatientAddressFormModal;
